export default {
  orderNumber: "",
  cart: [],
  CheckOrder: false
};
